import React, { useEffect, useState } from 'react'
import { injectIntl } from 'react-intl'
import DateRangePicker from './DateRangePicker'
import CheckBoxPicker from './CheckBoxPicker'
import DropDownPicker from './DropDownPicker'
import FilterInput from './FilterInput'
import ModalWindow from '../../../components/ModalWindow'
import { Button, Input } from 'semantic-ui-react'

import './Filter.css'
import DatePicker from 'react-date-picker'

function Filter(props) {
    const { filterList, filter, setFilter, disabled, isFilterActive, intl, className, style } = props
    const [state, setState] = useState({})
    const [open, setOpen] = useState(false)

    const translates = {
        filter: intl.formatMessage({ id: 'title.filter' }),
        accept: intl.formatMessage({ id: 'btn.accept' }),
        cancel: intl.formatMessage({ id: 'btn.cancel' })
    }

    const acceptHandler = () => {
        setFilter && setFilter(state)
        setOpen(false)
    }

    const cancelHandler = () => {
        setState(filter)
        setOpen(false)
    }

    const getButtons = () => {
        return [
            { title: translates.accept, onClick: acceptHandler, disabled: false, loading: false },
            { title: translates.cancel, onClick: cancelHandler, disabled: false, loading: false },
        ]
    }

    const getField = (field) => {
        switch (field.type) {
            case 'daterange': {
                return <DateRangePicker className="field" value={state[field.name]} onChange={value => setState({ ...state, [field.name]: value })} />
            }
            case 'date': {
                return <DatePicker className="field" format="yyyy.MM.dd" value={state[field.name]} onChange={value => setState({ ...state, [field.name]: value })} />
            }
            case 'checkbox': {
                return <CheckBoxPicker className="field" value={state[field.name]} options={field.options} onChange={value => setState({ ...state, [field.name]: value })} />
            }
            case 'dropdown': {
                return <DropDownPicker className="field" value={state[field.name]} options={field.options} onChange={value => setState({ ...state, [field.name]: value })} />
            }
            case 'input': {
                return <FilterInput className="field" value={state[field.name]} onChange={value => setState({ ...state, [field.name]: value })} />
            }
            case 'inputText': {
                return <Input className="field" fluid onChange={(e, { value }) => setState({ ...state, [field.name]: value })} value={state[field.name] || ''} />
            }

            default:
                console.error('Not found filter type: ', field.type)
        }
    }

    useEffect(() => {
        setState(filter)
    }, [filter]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ModalWindow
            iconType="info"
            title={translates.filter}
            open={open}
            onClose={cancelHandler}
            onOpen={() => setOpen(true)}
            trigger={
                <Button disabled={disabled} content={translates.filter} icon={isFilterActive ? { color: 'yellow', name: 'filter' } : "filter"} labelPosition="left" />
            }
            actions={getButtons()}
            className={className}
            style={style}
        >
            {filterList.map((field) => {
                return field.isHide !== true && (
                    <div key={field.name} className="filter row">
                        <span className="title">{field.title}:</span>
                        {getField(field)}
                    </div>
                )
            })}
        </ModalWindow>
    )
}

export default injectIntl(Filter)
